/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')

// グローバル エラーキャッチ
window.axios.interceptors.response.use(null, function (err) {
  if (err.response.status === 401) {
    window.location.href = '/login'
  } else if (err.response.status === 419) {
    alert('ページの有効期限が切れました。')
    location.href = ''
  }
  return Promise.reject(err)
})

window.Vue = require('vue')
import VueRouter from 'vue-router'
import router from './routes/member'
// import * as Sentry from '@sentry/vue'
// import {Integrations} from '@sentry/tracing'

// const host = location.hostname
// if (host === 'tc-dev.actbe.jp' || host === 'credit.triple-crown.co.jp') {
//   Sentry.init({
//     Vue: Vue,
//     dsn: 'https://439ea954613849b7af72967de7e7e2e2@o418039.ingest.sentry.io/5730646',
//     integrations: [new Integrations.BrowserTracing()],
//     tracesSampleRate: 1.0
//   })
// }

// larabel-echo
import Echo from 'laravel-echo'
window.Pusher = require('pusher-js')
window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  cluster: process.env.MIX_PUSHER_APP_CLUSTER,
  forceTLS: process.env.MIX_APP_ENV !== 'local'
})

Vue.use(VueRouter)

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'

Vue.use(ElementUI, {locale})

import VueTouch from 'vue-touch'

Vue.use(VueTouch, {name: 'v-touch'})

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

import member from './components/Member.vue'

import store from './store/member/index'

import mixins from './mixins/common'
Vue.mixin(mixins)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
  el: '#app',
  router: router,
  template: '<member/>',
  store: store,
  components: {member}
})
